<template>
  <div class="modal product-modal">
    <div class="overlay" @click="$parent.closeProductModal"></div>
    <div class="wrapper">
      <img
        class="close"
        src="../img/close.svg"
        @click="$parent.closeProductModal"
      />
      <div class="container">
        <div class="flex">
          <div class="preview">
            <div class="product-img-wrapper">
              <img
                class="img"
                :src="$parent.imgDomain + $parent.chosenProoduct.img + '.png'"
              />
              <img src="../img/Polygon.svg" class="polygon-overlay" />
            </div>
          </div>
          <div class="text">
            <div class="name-container">
              <div class="category" v-if="categoryName">{{ categoryName }}</div>
              <div class="title dark">{{ $parent.chosenProoduct.name }}</div>
            </div>
            <div class="price-container">
              <div class="price">
                <span class="desc amount">{{
                  $parent.chosenProoduct.price
                }}</span>
                <img src="../img/coin.svg" class="coin" />
              </div>
              <div @click="buyProduct" class="button">
                <img src="../img/cart.svg" class="cart-icon" />
                ADD TO CART
              </div>
            </div>
          </div>
        </div>
        <div class="desc dark status">
          This product is available on radgrind server.
        </div>

        <transition name="fade">
          <div class="desc error" v-if="error">{{ error }}</div>
        </transition>
        <transition name="fade">
          <div class="desc dark error success" v-if="success">
            {{ success }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: "ProductModal",
  props: ["currency"],
  data: function () {
    return {
      error: "",
      success: "",
      categories: [],
    };
  },
  mounted() {
    this.getCategories();
  },
  watch: {
    '$parent.chosenProoduct': {
      handler() {
        // Пересчитываем категорию при изменении товара
        this.$forceUpdate();
      },
      immediate: true
    }
  },
  computed: {
    categoryName() {
      const item = this.$parent.chosenProoduct;
      if (!item) return '';
      
      // Если категория - строка (приоритет для нового API)
      if (item.category && typeof item.category === 'string') {
        return item.category.toUpperCase();
      }
      
      // Если категория - объект с name или text
      if (item.category && typeof item.category === 'object') {
        if (item.category.name) return item.category.name.toUpperCase();
        if (item.category.text) return item.category.text.toUpperCase();
      }
      
      // Ищем категорию по category_id (fallback для старого API)
      if (this.categories && this.categories.length) {
        const categoryId = item.category_id || item.categoryId;
        if (categoryId) {
          const category = this.categories.find(cat => cat.id === categoryId);
          if (category) {
            return (category.text || category.name || '').toUpperCase();
          }
        }
      }
      
      return '';
    }
  },
  methods: {
    getCategories() {
      axios
        .get("categories")
        .then((res) => {
          this.categories = res.data.payload.map(({ id, name, ...rest }) => ({
            id,
            text: name,
            ...rest,
          }));
        })
        .catch(() => {});
    },
    buyProduct() {
      axios
        .post("cart/add", {
          id: this.$parent.chosenProoduct.id,
          count: 1,
        })
        .then((res) => {
          let self = this;
          if (res.data.status === "OK") {
            this.success = "Added";
            this.$parent.getCartContents();
            setTimeout(function () {
              this.success = "";
              self.$parent.closeProductModal();
            }, 1500);
          }
          if (res.data.status === "ERROR") {
            this.error = res.data.message;
            setTimeout(function () {
              self.error = "";
            }, 1500);
          }
        })
        .catch((res) => {
          let self = this;
          this.error = res.response.data.message;
          console.log(res);
          setTimeout(function () {
            self.error = "";
          }, 1500);
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
  },
};
</script>
